/**
 * Shared constants + helpers usati da SetupPhase, RecordingPhase,
 * ReviewPhase e dal componente top-level Sopralluogo.
 * Estratti da Sopralluogo.jsx (iter v28 r298, ~1356→~70 righe nel principale).
 */
import Cookies from "js-cookie";
import { API } from "@/lib/api";

export function fileUrl(path) {
  const token = Cookies.get("vista_jwt");
  const qs = new URLSearchParams({ path });
  if (token) qs.append("auth", token);
  return `${API}/files?${qs.toString()}`;
}

export const CITY_PLACEHOLDER = "es. Milano, Roma, Torino…";
export const DEFAULT_ROOMS = ["Ingresso", "Soggiorno", "Cucina", "Camera", "Bagno", "Esterno"];
export const EXTRA_ROOM_SUGGESTIONS = ["Cameretta", "Studio", "Secondo bagno", "Balcone", "Terrazzo", "Cantina", "Box auto", "Pianta catastale"];
// iter 242: tipologie asciugate. Mono/bi/tri/quadrilocale e attico/loft
// rientrano in "appartamento" (l'agente li dice nel vocale, il sistema li
// estrae). Villa include villetta. "Altro" cattura terreno/box/magazzino.
export const PROPERTY_TYPES = ["appartamento", "ufficio", "negozio", "villa", "altro"];
export const CONDITION_LABELS = {
  nuovo: "Nuovo", ottimo: "Ottimo", buono: "Buono",
  normale: "Normale", scarso: "Scarso", da_ristrutturare: "Da ristrutturare",
};
export const CONDITIONS = Object.keys(CONDITION_LABELS);

export function fmtEur(n) {
  if (n == null) return "—";
  return "€ " + Math.round(n).toLocaleString("it-IT");
}
